<template>
  <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
    <v-sheet class="transactionTable contestTable" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
      <v-data-table :items-per-page="10" :headers="headers" :items="formattedParticipants">
        <template v-slot:item.rank="{ item }">
          <span :class="getRankColorClass(item.rank)">{{ formatRank(item.rank) }}</span>
        </template>

        <template v-slot:item.participant_name="{ item }">
          <div class="flexbox">
            <img :src="item.profile_pic_url || '@/assets/contestprofile.png'" :alt="item.participant_name"
              class="profile-image">
            <v-avatar size="47">
              <v-img
                :src="item?.profile_pic_url || require('@/assets/contestprofile.png') || `https://ui-avatars.com/api/?name=${item?.participant_name}&background=random`"></v-img>
            </v-avatar>
            <router-link class="custom-link" :to="generateProfileLink(item)">
              {{ item.participant_name }}
            </router-link>
          </div>
        </template>

        <template v-slot:item.total_profit="{ item }">
          {{ formatCurrency(item.total_profit) }}
        </template>

        <template v-slot:item.gain_percentage="{ item }">
          {{ item.gain_percentage }}%
        </template>
      </v-data-table>
    </v-sheet>
  </v-card>
</template>

<script>
export default {
  name: 'ContestTable',

  props: {
    participants: {
      type: Array,
      required: true,
      default: () => []
    },
  },

  data() {
    return {
      headers: [
        { text: "Rank", value: "rank", align: 'center', width: '80' },
        { text: "Name", value: "participant_name" },
        { text: "Account no", value: "account_no" },
        { text: "Profit", value: "total_profit", align: 'end' },
        { text: "Gain", value: "gain_percentage", align: 'end' }
      ]
    }
  },

  computed: {
    formattedParticipants() {
      return this.participants
    }
  },

  methods: {
    getRankColorClass(rank) {
      if (rank === 1) return 'text--green rank'
      if (rank === 2) return 'text-warning rank'
      if (rank === 3) return 'text-orange rank'
      return 'text-gray rank'
    },

    formatRank(rank) {
      return String(rank).padStart(2, '0')
    },

    generateProfileLink(item) {
      return {
        name: 'contestant-profile',
        params: {
          id: item.client_id,
          accountNo: item.account_no
        }
      }
    },

    formatCurrency(amount) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount)
    }
  }
}
</script>